import { NavigationState } from '../objects/navigationState';
import { NavigationActionTypes, TOGGLE_OPEN, SET_FLOATING } from './actionTypes';

const initialState: NavigationState = {
    open: true,
    floating: false
};

export default (state = initialState, action: NavigationActionTypes): NavigationState => {
    switch (action.type) {
        case TOGGLE_OPEN: {
            return {...state, open: action.payload};
        }
        case SET_FLOATING: {
            return {...state, floating: action.payload};
        }
        default:
            return state;
    }
};